// NOTE: Event name **MUST** be of 40 characters or less in length
export const enum GoogleAnalyticsEvent {
  TripOverviewInitiated = 'planner_overview_initiated',
  AccommodationCardEdited = 'planner_accommodation_card_edited',
  AccommodationFiltersAccommodationType = 'planner_accommodation_filter_accommodation_type',
  AccommodationFiltersBoardBasisFilter = 'planner_hotel_filter_meal',
  AccommodationFiltersRulesFilters = 'planner_hotel_filter_rules',
  AccommodationFiltersStarsRate = 'planner_accommodation_filter_stars_rate',
  AccommodationFiltersAmenitiesFilters = 'planner_accommodation_filter_popular_filters',
  AccommodationFiltersExperienceFilters = 'planner_accommodation_filter_experience_filters',
  ActivitiesFilter = 'planner_filter_activities',
  ActivitiesBannerForDestination = 'planner_explore_activities',
  DestinationChanged = 'planner_destination_changed',
  DestinationAdded = 'planner_destination_added',
  DestinationRemoved = 'planner_destination_removed',
  ErrorAddingBasket = 'planner_error_adding_to_basket',
  EditNoAvailableIngredient = 'planner_product_no_available_edited',
  GoToCheckout = 'planner_go_to_checkout',
  MonthChanged = 'planner_month_changed',
  NightsChanged = 'planner_nights_changed',
  PaxEndChanging = 'planner_pax_end_changing',
  PaxStartChanging = 'planner_pax_start_changing',
  ReisegigantenDeserializeOldRecipe = 'deserialize-old-recipe-reisegiganten',
  ReisegigantenNoAvailability = 'reisegiganten-no-availability',
  NoTransportSelected = 'planner_transport_no_selected',
  TransportSelected = 'planner_transport_selected',
  BookableTransportPortChanged = 'planner_transport_bookable_port_changed',
  HotelDetailsViewItemForECommerce = 'view_item',
}
